//
//
//
//
//
//
//
//
//

import { Switch } from "ant-design-vue";
import "ant-design-vue/es/switch/style/index.css"

export default {
  name: "TheSwitch",
  components: {
    'a-switch': Switch
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    hasLabelSlot() {
      return this.$slots.default && this.$slots.default.length > 0;
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
  },
  methods: {
    handleChange() {
      this.model = !this.model
    }
  }
}
